export default {
  snack: (state) => state.snack,
  snackColor: (state) => (state.snackColor),
  timeout: (state) => state.timeout
}
